import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#enrollment_summary",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Search Trainee Information")
  ])
], -1)
const _hoisted_3 = {
  id: "enrollment_summary",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5 pb-0" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row mb-7" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by Registration Number ", -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by Reference Code ", -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by NID ", -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by BCN ", -1)
const _hoisted_20 = { class: "col-md-2 mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Select Course and Submit to allow this Trainee for Multiple/Duplicate Enrollment")
  ])
], -1)
const _hoisted_24 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = { class: "card-body border-top p-5" }
const _hoisted_27 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institutes", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_40 = { class: "border-top pt-9" }
const _hoisted_41 = {
  key: 0,
  id: "trainee_profile"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_43 = { class: "profile-info pt-1 pb-1" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-sm-3" }
const _hoisted_46 = { class: "thumbnail" }
const _hoisted_47 = {
  href: "javascript:;",
  class: "",
  title: "Entity Logo"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "col-sm-9" }
const _hoisted_50 = { class: "table-responsive" }
const _hoisted_51 = { class: "table" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Registration Number")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference Number")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Name")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Father Name")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother Name")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "National ID")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Birth Certificate Number")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date of Birth")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Home District")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present Address")
], -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Address")
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alternative Mobile")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Religion")
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Highest Class Completed")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Attendance Percentage ")
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_71 = { class: "block" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h4", null, "Training Information", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_74 = { class: "table-responsive" }
const _hoisted_75 = { class: "table" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Partner")
], -1)
const _hoisted_77 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "entity",
  "data-search-key": "26",
  target: "_blank",
  title: "Training Partner"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Institute")
], -1)
const _hoisted_79 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "institute",
  "data-search-key": "",
  title: "Training Institute"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Course")
], -1)
const _hoisted_81 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "batch",
  "data-search-key": "2005",
  title: "Batch Number"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Batch")
], -1)
const _hoisted_83 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "batch",
  "data-search-key": "2005",
  title: "Batch Number"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Start Date")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training End Date")
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Duration")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Hour")
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_90 = { class: "pl-3 mt-3 row" }
const _hoisted_91 = { class: "col-md-4 d-flex align-items-center" }
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = {
  key: 1,
  class: "text-center"
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("h4", null, "No data found!", -1)
const _hoisted_95 = [
  _hoisted_94
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.registration_number) = $event)),
                      placeholder: "Search"
                    }, null, 512), [
                      [_vModelText, _ctx.trainee.registration_number]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.reference_number) = $event)),
                      placeholder: "Search"
                    }, null, 512), [
                      [_vModelText, _ctx.trainee.reference_number]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.nid) = $event)),
                      placeholder: "Search"
                    }, null, 512), [
                      [_vModelText, _ctx.trainee.nid]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.bcn) = $event)),
                      placeholder: "Search"
                    }, null, 512), [
                      [_vModelText, _ctx.trainee.bcn]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTraineeInfo())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_21
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showTraineeInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _hoisted_31,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.trainee.tranche_id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _hoisted_34,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Partner",
                        modelValue: _ctx.trainee.entity_id,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                        filterable: "",
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trainingInstitute())),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: assoc.id,
                              label: assoc.entity_short_name,
                              value: assoc.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _hoisted_37,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Institute",
                        modelValue: _ctx.trainee.training_institute_id,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                        filterable: "",
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getCourseList())),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: inst.id,
                              label: inst.institute_name,
                              value: inst.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inst.institute_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "collapse-tags": "",
                        placeholder: "Select Course",
                        modelValue: _ctx.trainee.course_info_id,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                        filterable: "",
                        multiple: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: course.id,
                              label: course.course_name,
                              value: course.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(course.course_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_ctx.traineeInfo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("h2", null, "Profile of: " + _toDisplayString(_ctx.traineeInfo?.trainee_name), 1),
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("a", _hoisted_47, [
                                    _createElementVNode("img", {
                                      class: "d-flex justify-content-center h-100 w-100",
                                      src: 
                                _ctx.api_url + _ctx.traineeInfo?.attach_file_info?.file_path
                              ,
                                      alt: ""
                                    }, null, 8, _hoisted_48)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("table", _hoisted_51, [
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _hoisted_52,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.registration_number), 1),
                                        _hoisted_53,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.reference_number), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_54,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.trainee_name), 1),
                                        _hoisted_55,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.gender), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_56,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.father_name), 1),
                                        _hoisted_57,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.mother_name), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_58,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.nid), 1),
                                        _hoisted_59,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.bcn), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_60,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.moment(_ctx.traineeInfo?.date_of_birth).format("DD-MM-YYYY")), 1),
                                        _hoisted_61,
                                        _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.home_district_info
                                      ?.district_name_eng), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_62,
                                        _createElementVNode("td", null, ":" + _toDisplayString(_ctx.traineeInfo?.present_address), 1),
                                        _hoisted_63,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.per_address), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_64,
                                        _createElementVNode("td", null, ":" + _toDisplayString(_ctx.traineeInfo?.mobile), 1),
                                        _hoisted_65,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.alternative_mobile), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_66,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.email), 1),
                                        _hoisted_67,
                                        _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.religion), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_68,
                                        _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.highest_class_completed), 1),
                                        _hoisted_69,
                                        _hoisted_70
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _hoisted_73,
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("table", _hoisted_75, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_76,
                                      _createElementVNode("td", null, [
                                        _createTextVNode(" : "),
                                        _createElementVNode("a", _hoisted_77, _toDisplayString(_ctx.traineeInfo?.entity_info?.entity_name), 1)
                                      ]),
                                      _hoisted_78,
                                      _createElementVNode("td", null, [
                                        _createTextVNode(" : "),
                                        _createElementVNode("a", _hoisted_79, _toDisplayString(_ctx.traineeInfo?.institute_info?.institute_name), 1)
                                      ]),
                                      _hoisted_80,
                                      _createElementVNode("td", null, [
                                        _createTextVNode(" : "),
                                        _createElementVNode("a", _hoisted_81, _toDisplayString(_ctx.traineeInfo?.course_info?.course_name), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_82,
                                      _createElementVNode("td", null, [
                                        _createTextVNode(" : "),
                                        _createElementVNode("a", _hoisted_83, _toDisplayString(_ctx.traineeInfo?.batch_info?.batch_sequence_number), 1)
                                      ]),
                                      _hoisted_84,
                                      _createElementVNode("td", null, ":" + _toDisplayString(_ctx.moment(_ctx.traineeInfo?.batch_info?.start_date).format("DD-MM-YYYY")), 1),
                                      _hoisted_85,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.moment(_ctx.traineeInfo?.batch_info?.end_date).format("DD-MM-YYYY")), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_86,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.course_info?.month) + " Months", 1),
                                      _hoisted_87,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.course_info?.hour) + " Hours", 1),
                                      _hoisted_88,
                                      _hoisted_89
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "form-check-input rounded-0 mr-2",
                                    checked: "",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.allowMultiple) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.allowMultiple]
                                  ]),
                                  _createTextVNode(" Allow for Duplicate/Multiple Enrollment ")
                                ]),
                                _createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("button", {
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.allowEnroll(_ctx.traineeInfo?.id))),
                                    type: "button",
                                    class: "btn btn-success",
                                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                                  }, " Submit ")
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_93, _hoisted_95))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.load]
  ])
}